var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPausebutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_56_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "#1A1A1A",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 58,
    height: 58,
    rx: 29,
    stroke: "#333333"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3077 21H23.2308C22.9043 21 22.5913 21.1297 22.3605 21.3605C22.1297 21.5913 22 21.9043 22 22.2308V35.7692C22 36.0956 22.1297 36.4087 22.3605 36.6395C22.5913 36.8703 22.9043 37 23.2308 37H26.3077C26.4693 37 26.6294 36.9682 26.7787 36.9063C26.928 36.8445 27.0637 36.7538 27.178 36.6395C27.2923 36.5252 27.3829 36.3895 27.4448 36.2402C27.5066 36.0909 27.5385 35.9309 27.5385 35.7692V22.2308C27.5385 22.0691 27.5066 21.9091 27.4448 21.7598C27.3829 21.6105 27.2923 21.4748 27.178 21.3605C27.0637 21.2462 26.928 21.1555 26.7787 21.0937C26.6294 21.0318 26.4693 21 26.3077 21Z",
    fill: "#B8B8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7686 21H33.6917C33.3653 21 33.0522 21.1297 32.8214 21.3605C32.5906 21.5913 32.4609 21.9043 32.4609 22.2308V35.7692C32.4609 36.0956 32.5906 36.4087 32.8214 36.6395C33.0522 36.8703 33.3653 37 33.6917 37H36.7686C37.095 37 37.4081 36.8703 37.6389 36.6395C37.8697 36.4087 37.9994 36.0956 37.9994 35.7692V22.2308C37.9994 21.9043 37.8697 21.5913 37.6389 21.3605C37.4081 21.1297 37.095 21 36.7686 21Z",
    fill: "#B8B8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3077 21H23.2308C22.9043 21 22.5913 21.1297 22.3605 21.3605C22.1297 21.5913 22 21.9043 22 22.2308V35.7692C22 36.0956 22.1297 36.4087 22.3605 36.6395C22.5913 36.8703 22.9043 37 23.2308 37H26.3077C26.4693 37 26.6294 36.9682 26.7787 36.9063C26.928 36.8445 27.0637 36.7538 27.178 36.6395C27.2923 36.5252 27.3829 36.3895 27.4448 36.2402C27.5066 36.0909 27.5385 35.9309 27.5385 35.7692V22.2308C27.5385 22.0691 27.5066 21.9091 27.4448 21.7598C27.3829 21.6105 27.2923 21.4748 27.178 21.3605C27.0637 21.2462 26.928 21.1555 26.7787 21.0937C26.6294 21.0318 26.4693 21 26.3077 21Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7686 21H33.6917C33.3653 21 33.0522 21.1297 32.8214 21.3605C32.5906 21.5913 32.4609 21.9043 32.4609 22.2308V35.7692C32.4609 36.0956 32.5906 36.4087 32.8214 36.6395C33.0522 36.8703 33.3653 37 33.6917 37H36.7686C37.095 37 37.4081 36.8703 37.6389 36.6395C37.8697 36.4087 37.9994 36.0956 37.9994 35.7692V22.2308C37.9994 21.9043 37.8697 21.5913 37.6389 21.3605C37.4081 21.1297 37.095 21 36.7686 21Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_56_13",
    x: -6,
    y: -6,
    width: 71,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_56_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_56_13",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausebutton);
export default __webpack_public_path__ + "static/media/Pause button.8283989b4cef8801236ca3f87f4d0569.svg";
export { ForwardRef as ReactComponent };